<template>
  <div class="fillcontain">
    <search-item @showDialog="showAddClasstypeDialog"></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="100"
          prop="id"
          label="id"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="classType"
          label="班级类型名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="courseHours"
          label="课时数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="courseColor"
          label="颜色"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sort"
          label="排序"
          align="left"
          width="50px"
        ></el-table-column>
        <el-table-column
          width="100"
          prop="courseTypeId"
          label="课程类型"
          align="left"
          :filters="this.coursetypeData"
          :filter-method="filterCourseType"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterCourseType(scope.row)"
              disable-transitions
              >{{ scope.row.courseTypeId }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="left" label="操作">
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditClasstype(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteClasstype(scope.row, scope.$index)"
              >删除</el-button
            >
            <el-button
              type="primary"
              icon="edit"
              size="mini"
              @click="onAddStudentModalShow(scope.row)"
              >添加学员</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addClasstypeDialog.show"
        :isShow="addClasstypeDialog.show"
        :dialogRow="addClasstypeDialog.dialogRow"
        :coursetypeList="addClasstypeDialog.coursetypeList"
        @getClassTypeList="getClassTypeList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
    <el-dialog
      title="批量添加学员"
      :visible.sync="batchAddStuDialogVisible"
      >
      <el-form
        ref="form"
        :model="chosenClass"
        style="margin: 10px; width: auto"
        labelPosition="top"
      >
        <el-form-item required prop="classType" label="班级类型" >
          <el-input
            type="text"
            placeholder="请输入课时数"
            v-model="chosenClass.classType"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item required prop="courseHours" label="课时数">
          <el-input
            type="text"
            placeholder="请输入课时数"
            v-model="chosenClass.courseHours"
             :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item required label="选择班级">
          <el-select v-model="chosenClass.classChoseId" placeholder="请选择" style="width:100%" @change="getClassStudent">
            <el-option
              v-for="item in courseOptions"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item required prop="courseHours" label="批量添加学生">
           <div style="margin-top:5px"><el-transfer filterable v-model="transferChosenData" :data="transferData"></el-transfer></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchAddStuDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitClassStudents">确 定</el-button>
      </span>
  </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as mutils from "@/utils/mUtils";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCourseDialog";
import Pagination from "@/components/pagination";
import { myTime, formatDateTime, formatDateTime1 } from "../../utils/date.js";
import { getClasstypes, deleteClasstype,allclasstypes,getAllStudentsByClassId,addClassAndStudents } from "@/api/courseType";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      coursetypeData: [],
      format_course_type_list: {},
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addClasstypeDialog: {
        show: false,
        dialogRow: {},
        coursetypeList: {},
      },
      courseData: {
        page: 1,
        limit: 20,
      },
      pageTotal: 0,
      // 用于列表筛选
      fields: {},
      //当前添加学生的课程
      chosenClass: '',
      batchAddStuDialogVisible: false,
      //模拟学生
      transferChosenData: [],
      transferData: [],
      // 选择课程的options
      courseOptions:[]
    };
  },
  filters: {
    filterTime(time) {
      return formatDateTime(time);
    },
    filterTime1(time) {
      var dd = myTime(time);
      return formatDateTime1(dd);
    },
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["courseSearch"]),
  },
  mounted() {
    this.getClassTypeList();
  },
  methods: {
    /**
     * 格式化状态
     */
    filterCourseType(value, item) {
      return this.format_course_type_list[value] == item.courseTypeId;
    },
    formatterCourseType(item) {
      const type = parseInt(item.courseTypeId);
      console.log(this.format_course_type_list[type]);
      return this.format_course_type_list[type];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    //获取预约类型列表
    getClassTypeList() {
      const para = this.courseData;
      getClasstypes(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.totalSize;
        this.tableData = res.data.data.courseTypeDataList;
        this.format_course_type_list = res.data.data.format_course_type_list;
        this.coursetypeData = res.data.data.courseTypeData;
        var coursetypedata = {
          coursetypeList: this.coursetypeData,
        };
        this.addClasstypeDialog.coursetypeList = coursetypedata;
      });
    },
    // 显示添加预约类型弹窗
    showAddClasstypeDialog(val) {
      this.$store.commit("SET_CLASSTYPE_DIALOG_TITLE", val);
      this.addClasstypeDialog.show = true;
    },
    hideAddFundDialog() {
      this.addClasstypeDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.courseData.page = val;
      this.getClassTypeList();
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.courseData.limit = val;
      this.getClassTypeList();
    },
    // 编辑操作方法
    onEditClasstype(row) {
      console.log(row);
      var param = Object.assign({}, row);
      this.addClasstypeDialog.dialogRow = {
        param,
      };
      this.showAddClasstypeDialog();
    },
    // 删除数据
    onDeleteClasstype(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          deleteClasstype(row.id).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.classType + ")班级类型操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getClassTypeList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COURSE_SEARCHBTN_DISABLED", isFlag);
    },
    calcStudentAge(startDate) {
      var date = new Date();
      startDate = new Date(startDate);
      var newDate = date.getTime() - startDate.getTime();
      // 向下取整  例如 10岁 20天 会计算成 10岁
      // 如果要向上取整 计算成11岁，把floor替换成 ceil
      return Math.floor(newDate / 1000 / 60 / 60 / 24 / 365);
    },
    //添加学员模态框
    onAddStudentModalShow(row) {
      allclasstypes({}).then(res => {
        this.courseOptions = res.data.data.courseTypeDataList
        this.chosenClass = row
        this.chosenClass.classChoseId = ''
        this.transferChosenData = []
        this.transferData = []
        this.batchAddStuDialogVisible = true
      })
    },
    getClassStudent() {
      console.log('发请求获取学生，选择班级id为：',this.chosenClass.classChoseId)
      getAllStudentsByClassId({id:this.chosenClass.classChoseId}).then(res => {
        this.transferData = res.data.data.studentList.map(item => {
          return {
            key: item.stdId,
            label: item.stdName + ' ' + this.calcStudentAge(item.stdBirthday) + '岁'
          }
        })
      })
    },
    submitClassStudents() {
      console.log('添加学生，学生id:',this.transferChosenData,'班级id',this.chosenClass.id)
      addClassAndStudents({classTypeId: this.chosenClass.id,stdIds: this.transferChosenData.join(',')}).then(res => {
        this.transferChosenData = [],
        this.transferData =[]
        this.batchAddStuDialogVisible = false
        this.$message({
          message: "添加成功",
          type: "success",
        });
      })
      
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
</style>


